import clsx from "clsx";
import { FC } from "react";
import { Link } from "react-router-dom";

const SidebarItem: FC<{
    to?: string;
    icon: JSX.Element;
    label: string;
    isExpanded: boolean;
    active?: boolean;
    onClick?: () => void;
}> = ({ to, icon, label, isExpanded, active, onClick }) => {
    const baseClasses = "flex items-center cursor-pointer hover:bg-gray-300 dark:hover:bg-[#1A1A1A80]  w-full h-[60px]";
    const content = (
        <>
            {icon}
            {isExpanded && (
                <p className="whitespace-nowrap font-manrope font-bold text-[18px] text-light-text-100 dark:text-dark-text-100 ml-[35px]">
                    {label}
                </p>
            )}
        </>
    );

    return to ? (
        <Link
            to={to}
            className={clsx(baseClasses, isExpanded ? "justify-start pl-[20px]" : "justify-center", {
                "bg-gray-300 dark:bg-[#1A1A1A80]": active,
            })}
        >
            {content}
        </Link>
    ) : (
        <div onClick={onClick} className={clsx(baseClasses, isExpanded ? "justify-start pl-[20px]" : "justify-center")}>
            {content}
        </div>
    );
};

export default SidebarItem;
